{
    "header": "טבלת תורמים",
    "addDoner": "הוסף תרומה",
    "add": "הוסף"
} 